import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslate } from "../Context/LanguageContext"

const Split = () => {

    const t = useTranslate("purchase")

    return (
        <div className={`split both`}>
            <section className='left'>
                <Link to="/contact"><h2>{t("left-heading")}</h2></Link>

                <div
                    className='content scrollbar'
                    role='region'
                    aria-label={t("left-heading")}
                    tabIndex={0}
                >
                    <p className='text-1'>{t("left-txt1")}</p>

                    <p className='bullet-point'>{t("left-pb1")}</p>
                    <p className='bullet-point'>{t("left-pb2")}</p>
                    <p className='bullet-point'>{t("left-pb3")}</p>
                    <p className='bullet-point'>{t("left-pb4")}</p>
                    <p className='bullet-point'>{t("left-pb5")}</p>

                    <p className='text-2'>{t("left-txt2")}</p>

                    <p className='bullet-point'>{t("left-pb6")}</p>
                    <p className='bullet-point'>{t("left-pb7")}</p>
                    <p className='bullet-point'>{t("left-pb8")}</p>
                    <p className='bullet-point'>{t("left-pb9")}</p>
                    <p className='bullet-point'>{t("left-pb10")}</p>
                </div>

            </section>

            <section className='right'>
                <Link to="/contact"><h2>{t("right-heading")}</h2></Link>

                <div
                    className='content scrollbar'
                    role='region'
                    aria-label={t("right-heading")}
                    tabIndex={0}
                >
                    <p className='text-1'>{t("right-txt1")}</p>
                    <p className='text-1'>{t("right-txt2")}</p>

                    <p className='bullet-point'>{t("right-pb1")}</p>
                    <p className='bullet-point'>{t("right-pb2")}</p>
                    <p className='bullet-point'>{t("right-pb3")}</p>
                    <p className='bullet-point'>{t("right-pb4")}</p>

                </div>
            </section>
        </div>
    );
}

export default Split;